import type React from "react";
import type { NumberInputType } from "app/pages/sales-intelligence/common-components/export-table/cells/types";
import { StyledInputWrapper, StyledIncrement, StyledInput, StyledDecrement } from "./style";

export const NumberInput = ({ onChange, step = 1, value = 1, disabled = false }: NumberInputType) => {
    const handleInput = ({ currentTarget }: React.SyntheticEvent<HTMLInputElement>) => {
        const currentValue = currentTarget.value;

        onChange(currentValue);
    };

    const handleIncrement = () => onChange(Number(value) + step);

    const handleDecrement = () => Number(value) !== 0 && onChange(Number(value) - step);

    return (
        <StyledInputWrapper>
            <StyledDecrement onClick={handleDecrement}>-</StyledDecrement>
            <StyledInput
                type="number"
                disabled={disabled}
                min={1}
                step={step}
                onChange={handleInput}
                value={value}
            />
            <StyledIncrement onClick={handleIncrement}>+</StyledIncrement>
        </StyledInputWrapper>
    );
};
